import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalContext from "../contexts/global";

export const getCurrentPage = () => {
  const location = useLocation();
  const pathname = location.pathname;
  
  const cleanPath = pathname.startsWith('/') ? pathname.substring(1) : pathname;
  
  if (!cleanPath || cleanPath === '/') {
    return 'home';
  }
  const segments = cleanPath.split('/');
  return segments[0];
};

export const useCurrentPage = () => {
  const location = useLocation();
  const pathname = location.pathname;
  
  const getCurrentPageName = () => {
    const cleanPath = pathname.startsWith('/') ? pathname.substring(1) : pathname;
    
    if (!cleanPath || cleanPath === '/') {
      return 'home';
    }
    
    const segments = cleanPath.split('/');
    return segments[0];
  };
  
  return {
    currentPage: getCurrentPageName(),
    fullPath: pathname,
    segments: pathname.split('/').filter(segment => segment !== '')
  };
};


const PageTitle = ({ parentPage, childPage, contentMessage }) => {
  const { currentPage } = useCurrentPage();
    const { global } = useContext(GlobalContext);

  const combinations = [
  {
    pathSegment: 'combos',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'COMBOS')
  },
  {
    pathSegment: 'lista-de-cadernos',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'LISTA_CADERNOS')
  },
    {
    pathSegment: 'dicas',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'DICAS')
  },
  {
    pathSegment: 'cadernosessenciais',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'SAUDE')
  },
    {
    pathSegment: 'meus-cadernos',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'MEUS_CADERNOS')
  },
  {
    pathSegment: 'acesso',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'ACESSO')
  },
    {
    pathSegment: 'colaboracoes',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'COLABORADORES')
  },
      {
    pathSegment: 'carrinho',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'CARRINHO')
  },
        {
    pathSegment: 'meus-livros',
    pageInfo: global.messageOnTopPage?.find(item => item?.type === 'MEUS_ESTUDOS')
  }
]


 const currentCombination = combinations.find(combination => currentPage === combination.pathSegment);

  return (
    <>
      <div
        className="dz-bnr-inr overlay-secondary-dark dz-bnr-inr-sm"
      
      >
        <div className="container">
          <div className="dz-bnr-inr-entry ">
            <h1>{currentCombination?.pageInfo?.title || contentMessage || childPage}</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row">
              <ul className="breadcrumb">
               {currentCombination?.pageInfo?.message ? (
                  <p className="m-0" style={{ fontSize: '1rem'}}>{currentCombination?.pageInfo?.message}</p>
               ):(
                <>
                 <li className="breadcrumb-item">
                  <Link to={""}>{parentPage}</Link>
                </li>
                <li className="breadcrumb-item">{childPage}</li>
                </>
               )}
               
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};
export default PageTitle;
